import { useAddBadge } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const AddBadge = () => {
  const { t } = useLocale();
  const BackIcon = useElement("BackIcon");
  const Input = useElement("Input");
  const Button = useElement("Button");
  const Box = useComponent("Box");
  const MediaBox = useComponent("MediaBox");
  const { setBadgeTitle, title, image, setimage, addBadge } = useAddBadge();
  return (
    <div id="content-box" className="content">
      <h1>
        <BackIcon backLink="/admin/badge/list" />
        {t("addBadge")}
      </h1>
      <div className="columns">
        <div className="left">
          <Box title={t("title")} required>
            <Input
              required
              name="title"
              value={title}
              onChange={setBadgeTitle}
            />
          </Box>
          <MediaBox
            image={image}
            setimage={(image) => setimage(image)}
            title="Badge Image"
            usage={["badge"]}
          />
        </div>
        <div className="right">
          <form noValidate onSubmit={addBadge}>
            <Box title={t("meta")}>
              <Button
                className="btn btn-primary"
                type="submit"
                title="Click here to Add badge"
              >
                {t("submit")}
              </Button>
            </Box>
          </form>
        </div>
      </div>
    </div>
  );
};
